import(/* webpackMode: "eager" */ "/app/node_modules/@next/third-parties/dist/google/ga.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@next/third-parties/dist/google/gtm.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@next/third-parties/dist/ThirdPartyScriptEmbed.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/font/google/target.css?{\"path\":\"src/app/(web)/layout.tsx\",\"import\":\"Comforter_Brush\",\"arguments\":[{\"variable\":\"--font-comforter-brush\",\"subsets\":[\"latin\"],\"weight\":\"400\",\"display\":\"swap\"}],\"variableName\":\"comforterBrush\"}");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/font/google/target.css?{\"path\":\"src/app/(web)/layout.tsx\",\"import\":\"Noto_Serif\",\"arguments\":[{\"variable\":\"--font-noto-serif\",\"weight\":[\"300\",\"400\",\"500\",\"600\",\"700\"],\"style\":[\"normal\"],\"subsets\":[\"latin\"],\"display\":\"swap\"}],\"variableName\":\"notoSerif\"}");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/font/google/target.css?{\"path\":\"src/app/(web)/layout.tsx\",\"import\":\"Noto_Sans\",\"arguments\":[{\"variable\":\"--font-noto-sans\",\"weight\":[\"400\",\"500\",\"600\",\"700\",\"800\",\"900\"],\"style\":[\"normal\",\"italic\"],\"subsets\":[\"latin\"],\"display\":\"swap\"}],\"variableName\":\"notoSans\"}");
;
import(/* webpackMode: "eager" */ "/app/src/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["PostHogProvider"] */ "/app/src/app/providers.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AppPostMessage"] */ "/app/src/components/app-postmessage.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/appBar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/infront/ticker.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/javascript-button.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/kilkaya-spa-ready.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/navigation/navigation.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/podcast-player.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/settings.ts");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/sidebar/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/skip-link.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/sub-navigation.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/todays-important/client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["InfrontContextProvider"] */ "/app/src/context/infront-context/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["MenuContextProvider"] */ "/app/src/context/menu-context.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PlayerContextProvider"] */ "/app/src/context/player-context.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SidebarContextProvider"] */ "/app/src/context/sidebar-context.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ThemeContextProvider"] */ "/app/src/context/theme-context.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["UnitProvider"] */ "/app/src/context/unit-context.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["UserContextProvider"] */ "/app/src/context/user-context.tsx");
